import React from 'react';
import { YearMonth } from '../../model/datePicker/types';
import './panelHeader.scss';
import { t, tList } from '../../i18n';

const MONTH_NAMES = tList('dates.months');

const parseYearMonth = (ym: YearMonth): { year: number, month: number } => {
  const [ year, month ] = ym.split('-').map(Number);
  return { year, month };
};

const formatYearMonth = (year: number, month: number): YearMonth =>
  `${year}-${String(month).padStart(2, '0')}` as YearMonth;

// Cabecera de un panel: desplegables mes/año + navegación ‹ › — §04. El
// cableado de si desplaza solo este panel o la pareja enlazada lo decide
// quien despacha la acción (DatePickerPanel), no este componente.
const PanelHeader = ({ month, slotLabel, onNav, onSetMonth }: Props) => {
  const { year, month: monthNum } = parseYearMonth(month);
  const yearOptions = Array.from({ length: 8 }, (_, i) => year - 6 + i);

  return (
    <div className="rdp-panel-header">
      {
        slotLabel &&
          <div className={`rdp-panel-header__slot rdp-panel-header__slot--${slotLabel.axis.toLowerCase()}`}>
            <span className="rdp-panel-header__dot" />
            {slotLabel.text}
          </div>
      }
      <div className="rdp-panel-header__controls">
        <div className="rdp-panel-header__selects">
          <select
            className="rdp-panel-header__select"
            aria-label={t('datePicker.month')}
            value={monthNum}
            onChange={e => onSetMonth(formatYearMonth(year, Number(e.target.value)))}
          >
            {
              MONTH_NAMES.map((name, index) => (
                <option key={name} value={index + 1}>{name}</option>
              ))
            }
          </select>
          <select
            className="rdp-panel-header__select"
            aria-label={t('datePicker.year')}
            value={year}
            onChange={e => onSetMonth(formatYearMonth(Number(e.target.value), monthNum))}
          >
            {
              yearOptions.map(y => <option key={y} value={y}>{y}</option>)
            }
          </select>
        </div>
        <div className="rdp-panel-header__nav-group">
          <button type="button" className="rdp-panel-header__nav" aria-label={t('datePicker.previousMonth')} onClick={() => onNav(-1)}>‹</button>
          <button type="button" className="rdp-panel-header__nav" aria-label={t('datePicker.nextMonth')} onClick={() => onNav(1)}>›</button>
        </div>
      </div>
    </div>
  );
}

interface Props {
  month: YearMonth,
  slotLabel?: { text: string, axis: 'A' | 'B' }, // solo en Mode=Custom
  onNav: (delta: number) => void,
  onSetMonth: (month: YearMonth) => void
}

export { PanelHeader };
